import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';

import MuiTable from '@material-ui/core/Table';
import MuiTableBody from '@material-ui/core/TableBody';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTableContainer from '@material-ui/core/TableContainer';
import MuiTableHead from '@material-ui/core/TableHead';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiPaper from '@material-ui/core/Paper';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import MuiTablePagination from '@material-ui/core/TablePagination';

import Row from './Row';

const styles = () => ({
  loadWrapper: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1rem 0',
  },
  actionRow: {
    display: 'flex',
    margin: '1rem 0',
  },
});

const TableDistributionHistory = props => {
  const { classes, page, setPage, pageSize, setPageSize, isLoading, distributionJobs } = props;

  const [editingId, setEditingId] = useState(null);

  const total = distributionJobs?.total;
  const dataDistributionHistory = distributionJobs?.data;

  const handleEditRow = id => {
    setEditingId(id);
  };

  const handleChangeRowsPerPage = event => {
    setPageSize(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  return (
    <>
      <MuiTableContainer component={MuiPaper}>
        {isLoading ? (
          <div className={classes.loadWrapper}>
            <MuiCircularProgress />
          </div>
        ) : (
          <MuiTable aria-label="collapsible table">
            <MuiTableHead>
              <MuiTableRow>
                <MuiTableCell>Release Title</MuiTableCell>
                <MuiTableCell>DSP</MuiTableCell>
                <MuiTableCell>UPC</MuiTableCell>
                <MuiTableCell>ERN Type</MuiTableCell>
                <MuiTableCell>Status</MuiTableCell>
                <MuiTableCell>Started/Completed</MuiTableCell>
                <MuiTableCell>Sender</MuiTableCell>
                <MuiTableCell align="right"></MuiTableCell>
              </MuiTableRow>
            </MuiTableHead>
            <MuiTableBody>
              <MuiTableRow>
                <MuiTablePagination
                  rowsPerPageOptions={[25, 50, 100]}
                  rowsPerPage={pageSize}
                  count={total || 0}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </MuiTableRow>
              {dataDistributionHistory?.map(row => (
                <Row key={row.id} editing={editingId === row.id} onEditChange={handleEditRow} row={row} />
              ))}
              <MuiTableRow>
                <MuiTablePagination
                  rowsPerPageOptions={[25, 50, 100]}
                  rowsPerPage={pageSize}
                  count={total || 0}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </MuiTableRow>
            </MuiTableBody>
          </MuiTable>
        )}
      </MuiTableContainer>
    </>
  );
};

TableDistributionHistory.defaultProps = {};

export default withStyles(styles)(withRouter(TableDistributionHistory));
